import * as React from 'react';
import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { Button } from '../ButtonV2/Button';

export interface PillGroupCategory {
  categoryKey: string;
  translatedName: string;
}

export interface PillGroupProps {
  categories: PillGroupCategory[];
  onClick: (categoryKey: string) => void;
  externalSelectedKey?: string;
  className?: string;
  buttonClassName?: string;
}

export const PillGroup: React.FC<PillGroupProps> = ({
  categories,
  onClick,
  externalSelectedKey,
  className,
  buttonClassName,
}) => {
  const [selectedIdx, setSelectedIdx] = useState(0);

  useEffect(() => {
    const newSelectedIdx = categories.findIndex(
      (category) => category.categoryKey === externalSelectedKey,
    );
    if (newSelectedIdx > -1) setSelectedIdx(newSelectedIdx);
  }, [externalSelectedKey]);

  const handleButtonClick = (index: number) => {
    setSelectedIdx(index);
    onClick(categories[index].categoryKey);
  };

  return (
    <div
      className={clsx(
        'flex space-x-2 overflow-x-auto whitespace-nowrap',
        className,
      )}
      data-testid='category-pill-buttons'
      style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
      }}
    >
      {categories.map((item, index) => (
        <Button
          className={clsx(
            'min-w-max px-4',
            index === selectedIdx ? 'activePill' : 'inactivePill',
            buttonClassName,
          )}
          key={`pill-group-${item.categoryKey}`}
          onClick={() => handleButtonClick(index)}
          size='small'
          variant={index === selectedIdx ? 'activePill' : 'inactivePill'}
        >
          {item.translatedName}
        </Button>
      ))}
    </div>
  );
};
